// Types
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

// Routes
import {
    ANALYZE_OVERVIEW,
    ANALYZE_REACH_IMPRESSIONS,
    MANAGE_COMMENTS_TRACKER,
    SCHEDULER
} from '@/lib/routes/privateRoutes';
import { LINKEDIN, TIKTOK_BUSINESS, X, YOUTUBE } from '@/lib/socialProfile';

import { GLOBAL_EVENT_TYPES } from '@/components/composite/Listeners/GlobalEventsListener';

export type NewFeatureReleasedType = {
    name: string;
    date: string;
    urls?: string[];
    globalEventQuery?: keyof typeof GLOBAL_EVENT_TYPES;
    socialNetworkType?: SocialProfileNetworkType[];
    /** Optional i18n key for tooltip on the "new" badge */
    tooltip?: string;
    parentMenu?: boolean;
};

const NEW_FEATURES_RELEASED: NewFeatureReleasedType[] = [
    // INFO : To create a new notification for a feature just released add a new entry below using this pattern
    /*
    {
        name: 'new_feature_name', -> This will be used to store the notification "as read" in cookie
        date: '2022-06-07', -> The date of the release in YYYY-MM-DD format
        urls: [ANALYZE_OVERVIEW], -> The list of urls impacted by the new feature
        globalEventQuery: GLOBAL_EVENT_TYPES.TIKTOK_UPGRADE_API -> A global event query token
        socialNetworkType: [FACEBOOK] -> Optional : Don't use this property if the new feature is not restricted by social network type
    },
    */
    {
        name: 'linkedin_comments',
        date: '2024-04-10',
        urls: [MANAGE_COMMENTS_TRACKER],
        socialNetworkType: [LINKEDIN]
    },
    {
        name: 'tiktok_reach_impressions',
        date: '2026-02-02',
        urls: [ANALYZE_REACH_IMPRESSIONS],
        socialNetworkType: [TIKTOK_BUSINESS]
    },
    {
        name: 'youtube_scheduling',
        date: '2026-03-13',
        urls: [SCHEDULER],
        socialNetworkType: [YOUTUBE],
        tooltip: 'commons:new_features.youtube_shorts_scheduling'
    },
    {
        name: 'x_analytics',
        date: '2026-03-12',
        urls: [ANALYZE_OVERVIEW],
        socialNetworkType: [X],
        parentMenu: true
    }
];

export default NEW_FEATURES_RELEASED;
